import { FaRegStar } from "react-icons/fa";
import TitleStripe from "../TitleStripe";
import { getLetterScore, getScoreLegends } from "../../../utils/utils";

const RatingCredito = ({ rating }) => {
  const score = Number(rating?.score);
  if (rating?.score == null || !Number.isFinite(score)) return null;

  // getLetterScore só tem letra até 999: o 1000 cairia fora da tabela.
  const letra = getLetterScore(Math.min(Math.max(score, 0), 999));

  return (
    <div>
      <TitleStripe className="mb-4">
        <div className="flex items-center gap-2">
          <FaRegStar className="text-blue-700" />
          <span>Rating de crédito</span>
        </div>
      </TitleStripe>

      <div className="grid grid-cols-3 gap-4">
        <div className="p-6 bg-white rounded-2xl border border-gray-200 flex items-center justify-between gap-3">
          <div>
            <div className="text-sm font-medium text-gray-600">Rating</div>
            <div className="text-4xl font-extrabold text-gray-800">{score}</div>
            <div className="text-xs text-gray-500">Escala de 0 a 1000</div>
          </div>
          <div className="rounded-xl border border-blue-200 bg-blue-50 px-4 py-2 text-2xl font-extrabold text-blue-800">
            {letra}
          </div>
        </div>

        <div className="col-span-2 p-6 bg-white rounded-2xl border border-gray-200 text-sm text-gray-700">
          <div className="font-semibold mb-1">Descritivo</div>
          <div className="text-gray-600">{getScoreLegends(letra)}</div>
        </div>
      </div>

      <div className="mt-2 text-xs text-gray-500 italic">
        Rating calculado por inteligência artificial a partir das informações
        desta consulta (restrições, dados cadastrais e comportamento de
        pagamento). Não substitui a avaliação de crédito da instituição
        concedente.
      </div>
    </div>
  );
};

export default RatingCredito;
